import { ThemeSchemaResponse } from '@toggle/toggle';
import React from 'react';
import { useTranslation } from 'react-i18next';

import { ThemeLogoIcon } from '~/views/theme-overview/components/theme-logo-icon/ThemeLogoIcon';

import styles from './ThemeHeaderDetailed.module.scss';

export interface ThemeHeaderDetailedProps {
  theme: Pick<ThemeSchemaResponse, 'logo_url' | 'name' | 'description'>;
  title?: string;
}

export const ThemeHeaderDetailed = ({
  theme,
  title,
}: ThemeHeaderDetailedProps) => {
  const { t } = useTranslation(['widget']);

  return (
    <div className={styles.header}>
      <div className={styles.headerContent}>
        <ThemeLogoIcon logo_url={theme.logo_url} name={theme.name} />
        <span>
          <div className={styles.titleText}>{title ?? theme.name}</div>
          <div className={styles.subtitleSmall}>
            {t('assetOverview.knowledgeGraph.themeExposure.investmentTheme')}
          </div>
        </span>
      </div>
      <div className={styles.bodySmall}>{theme.description}</div>
    </div>
  );
};
